import { render, staticRenderFns } from "./SendAsMessage.vue?vue&type=template&id=635aa0ce"
import script from "./SendAsMessage.vue?vue&type=script&lang=js"
export * from "./SendAsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports